import type { LngLat, PixelCoordinates } from '@yandex/ymaps3-types';
import type { Coordinates } from 'src/components/YandexMap/types';

type PixelShift = {
  x: number;
  y: number;
};

/**
 * Вычисляет новый центр карты с учетом смещения
 * @param leftTop Координаты левого верхнего угла
 * @param rightBottom Координаты правого нижнего угла
 * @param centerCoordinates Координаты центра карты
 * @param mapSize Размер карты в пикселях
 * @param pixelShift Смещение карты в пикселях
 */
export const calculateMapCenter = (
  leftTop: LngLat,
  rightBottom: LngLat,
  centerCoordinates: Coordinates,
  mapSize: PixelCoordinates,
  pixelShift: PixelShift = { x: 0, y: 0 },
): Coordinates => {
  // Вычисление размера карты в градусах
  const latitudeDelta = rightBottom[0] - leftTop[0];
  const longitudeDelta = leftTop[1] - rightBottom[1];

  // Вычисление масштаба преобразования пикселей в координаты
  const scaleLatitude = latitudeDelta / mapSize.y;
  const scaleLongitude = longitudeDelta / mapSize.x;

  // Вычисление центра карты без учета смещения
  const centerLatitude = centerCoordinates[0];
  const centerLongitude = centerCoordinates[1];

  // Преобразование смещения из пикселей в градусы
  const shiftLatitude = pixelShift.x * scaleLatitude;
  const shiftLongitude = pixelShift.y * scaleLongitude;

  // Применение смещения к центру карты
  const shiftedCenterLatitude = centerLatitude + shiftLatitude;
  const shiftedCenterLongitude = centerLongitude - shiftLongitude; // Долгота уменьшается слева направо

  return [shiftedCenterLatitude, shiftedCenterLongitude];
};
